import { render, staticRenderFns } from "./Palette.vue?vue&type=template&id=97c90e2c"
import script from "./Palette.vue?vue&type=script&lang=ts"
export * from "./Palette.vue?vue&type=script&lang=ts"
import style0 from "./Palette.vue?vue&type=style&index=0&id=97c90e2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports